'use strict'

// This module must adhere to es5 (not es6) for consumption in other repos.

// The features included in the plans below are checked against this list
exports.feature_list = [
    'byod', // Page can be served on a domain you own (bring your own domain)
    'contact_me', // You can use the Contact Me social icon
    'domain', // A domain that about.me purchases for you
    'gallery', // Image gallery
    'google_apps', // Gmail, calendar, drive, all that jazz
    'no_branding', // No mention of about.me on your page/domain
    'pro_spotlights', // Spotlights not available to free users
    'testimonials', // You can use the Testimonials feature
    'video', // You can embed a video on your page
    'ai_chat', // AI Chat embed on your page
]

// Figure out if this is prod in a way that won't break on the client.
// `stripe_plan_id` is only used in node so this won't matter in the browser.
var is_node = typeof(process) !== 'undefined'
var node_env = is_node && process.env.NODE_ENV
var is_production = node_env && node_env === 'production'

// Important note: Prices are all referenced in cents.

exports.list = [
    {
        id: 'legacy_premium',
        stripe_plan_id: 'premium',
        title: 'Pro',
        is_recurring: true,
        recurs: 'yearly',
        price: 4800,
        features: [
            'byod',
            'contact_me',
            'domain',
            'gallery',
            'no_branding',
            'pro_spotlights',
            'testimonials',
            'video',
        ],
        type: 'plan',
        is_available: true,
    },
    {
        id: 'starter',
        stripe_plan_id: 'starter',
        title: 'Pro',
        is_recurring: true,
        recurs: 'yearly',
        price: 7900,
        features: [
            'byod',
            'contact_me',
            'domain',
            'gallery',
            'no_branding',
            'pro_spotlights',
            'testimonials',
            'video',
        ],
        type: 'plan',
        is_available: true,
    },
    {
        id: 'starter_4800',
        stripe_plan_id: is_production ? 'price_0JaSQLJWR1Mw8Cp3tqgBCO0v' : 'price_0JY0cegh7B9oZ5vJzIgpWioi',
        title: 'Pro',
        is_recurring: true,
        recurs: 'yearly',
        price: 4800,
        features: [
            'byod',
            'contact_me',
            'domain',
            'gallery',
            'no_branding',
            'pro_spotlights',
            'testimonials',
            'video',
        ],
        type: 'plan',
        is_available: true,
    },
    {
        id: 'starter_monthly',
        stripe_plan_id: 'starter_monthly',
        title: 'Pro',
        is_recurring: true,
        recurs: 'monthly',
        price: 800,
        features: [
            'byod',
            'contact_me',
            'domain',
            'gallery',
            'no_branding',
            'pro_spotlights',
            'testimonials',
            'video',
        ],
        type: 'plan',
        is_available: true,
    },
    {
        id: 'professional',
        stripe_plan_id: 'professional',
        title: 'Pro Plus',
        is_recurring: true,
        recurs: 'yearly',
        price: 24900,
        features: [
            'byod',
            'contact_me',
            'domain',
            'gallery',
            'google_apps',
            'no_branding',
            'pro_spotlights',
            'testimonials',
            'video',
        ],
        type: 'plan',
        is_available: false,
    },
    {
        id: 'professional_monthly',
        stripe_plan_id: 'monthly_pro',
        title: 'Pro Plus',
        is_recurring: true,
        recurs: 'monthly',
        price: 2500,
        features: [
            'byod',
            'contact_me',
            'domain',
            'gallery',
            'google_apps',
            'no_branding',
            'pro_spotlights',
            'testimonials',
            'video',
        ],
        type: 'plan',
        is_available: false,
    },
    {
        id: 'addon_domain',
        stripe_plan_id: 'domain',
        title: 'Add-on Domain',
        is_recurring: true,
        recurs: 'yearly',
        //price: 0, // domain cost is variable
        features: [],
        type: 'domain',
        is_available: true,
    },

    // New pro plans that include AI Chat
    {
        id: 'pro',
        stripe_plan_id: is_production ? 'price_0RoCngJWR1Mw8Cp3i7sWFWn9' : 'price_0RoCHygh7B9oZ5vJ2ryL79VE',
        title: 'Pro',
        is_recurring: true,
        recurs: 'yearly',
        price: 9000,
        features: [
            'byod',
            'contact_me',
            'domain',
            'gallery',
            'no_branding',
            'pro_spotlights',
            'testimonials',
            'video',
            'ai_chat',
        ],
        type: 'plan',
        is_available: true,
    },
    {
        id: 'pro_monthly',
        stripe_plan_id: is_production ? 'price_0RoCnOJWR1Mw8Cp3GJd3z11l' : 'price_0RoCHPgh7B9oZ5vJxXFa9e7a',
        title: 'Pro',
        is_recurring: true,
        recurs: 'monthly',
        price: 900,
        features: [
            'byod',
            'contact_me',
            'domain',
            'gallery',
            'no_branding',
            'pro_spotlights',
            'testimonials',
            'video',
            'ai_chat',
        ],
        type: 'plan',
        is_available: true,
    },

    // New plans for just AI Chat
    {
        id: 'standard',
        stripe_plan_id: is_production ? 'price_0RqiDIJWR1Mw8Cp3npVixdoZ' : 'price_0RoCH1gh7B9oZ5vJPZPzfJEz',
        is_recurring: true,
        recurs: 'yearly',
        title: 'Standard',
        price: 6000,
        features: [
            'ai_chat',
        ],
        type: 'plan',
        is_available: true,
    },
    {
        id: 'standard_monthly',
        stripe_plan_id: is_production ? 'price_0RqiDVJWR1Mw8Cp3P181ywdW' : 'price_0RoCGDgh7B9oZ5vJ63ZffvEF',
        is_recurring: true,
        recurs: 'monthly',
        title: 'Standard',
        price: 600,
        features: [
            'ai_chat',
        ],
        type: 'plan',
        is_available: true,
    },
]

// export index of products by id as well
exports.index = {}
exports.list.forEach(function (product) {
    exports.index[product.id] = product
})


/* Outputs an array of features a user has from their purchases mongo doc
 * Checks for current subscriptions.
 * @param {Object} purchases_doc - The user's purchases document from mongo
 * @return Array of string feature names
 */
exports.getFeatureList = function getFeatureList(purchases_doc) {
    var output = []
    var purchased_products = (
        purchases_doc
        && purchases_doc.products instanceof Array
        && purchases_doc.products
    )

    // if they have no purchases... no features
    if (!purchased_products) return output

    // get the list of features
    purchased_products.forEach(function forEachProduct(product) {
        var product_definition = exports.index[product.product_id]

        // make sure it's a valid product id
        if (product_definition) {
            // NOTE: this was copied from purchases.js in the me-model repo
            // to prevent a dependency hell. Please change in both places.
            // P.S. this can't go in etcd because this module is used in the
            // browser.
            var good_statuses = ['active', 'trialing', 'cancel_pending']

            var subscription_active = good_statuses.indexOf(product.status) > -1

            // then make sure the user's plan is active
            // or maybe they don't need a plan
            if (subscription_active || !product_definition.is_recurring) {
                output.push.apply(output, product_definition.features)
            }
        }
    })

    return output
}
